import { Box, Button, Grid, Group, Modal, SegmentedControl, Text, Textarea, TextInput } from '@mantine/core';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import Regex from '../../constants/Regex';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';

const PartnerModal = ({ partner: passedPartner, onClose, onSave }) => {
  const fetch = useFetch();

  const [partner, setPartner] = useState(passedPartner);
  const [userError, setUserError] = useState();

  useEffect(() => {
    setPartner(passedPartner);
  }, [passedPartner]);

  if (partner === undefined) {
    return '';
  }

  const savePartner = (e) => {
    e.preventDefault();
    setUserError(undefined);

    const fetchFunc = partner?.id
      ? fetch(`/api/admin/partners/${partner.id}`, {
          method: 'PUT',
          body: JSON.stringify({ partner }),
        })
      : fetch(`/api/admin/partners`, {
          method: 'POST',
          body: JSON.stringify({ partner }),
        });

    fetchFunc
      .then(({ partner }) => {
        onSave(partner);
        onClose();
      })
      .catch(setUserError);
  };

  return (
    <>
      <Modal opened={!!passedPartner} onClose={onClose} size="lg" title={`${partner?.id ? 'Edit' : 'Add'} Partner`}>
        <Box component="form" ta="left">
          <Grid>
            <Grid.Col span={{ base: 12, sm: 4 }}>
              <Text size="sm" fw={500}>
                Name*
              </Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 8 }}>
              <TextInput
                name="name"
                required
                error={partner.name === ''}
                value={partner.name || ''}
                onChange={(e) => setPartner({ ...partner, [e.target.name]: e.target.value })}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, sm: 4 }}>
              <Text size="sm" fw={500}>
                Email*
              </Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 8 }}>
              <TextInput
                name="email"
                type="email"
                error={partner.email !== undefined && !Regex.emailRegex.test(partner.email)}
                required
                value={partner.email || ''}
                onChange={(e) => setPartner({ ...partner, [e.target.name]: e.target.value })}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, sm: 4 }}>
              <Text size="sm" fw={500}>
                Phone number*
              </Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 8 }}>
              <TextInput
                name="phoneNumber"
                required
                error={partner.phoneNumber === ''}
                value={partner.phoneNumber || ''}
                onChange={(e) => setPartner({ ...partner, [e.target.name]: e.target.value })}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, sm: 4 }}>
              <Text size="sm" fw={500}>
                Public key
              </Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 8 }}>
              <Textarea
                name="publicKey"
                rows={8}
                value={partner.publicKey || ''}
                onChange={(e) => setPartner({ ...partner, [e.target.name]: e.target.value })}
              />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={{ base: 12, sm: 4 }}>
              <Text size="sm" fw={500}>
                Billing*
              </Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 8 }}>
              <SegmentedControl
                value={partner.billingManagement ?? ''}
                onChange={(billingManagement) => setPartner({ ...partner, billingManagement })}
                data={[
                  { label: 'Releva', value: 'internal' },
                  { label: 'Partner', value: 'external' },
                ]}
              />
            </Grid.Col>
          </Grid>
          {partner.billingManagement === 'external' && (
            <>
              <Grid>
                <Grid.Col span={{ base: 12, sm: 4 }}>
                  <Text size="sm" fw={500}>
                    Usage record create webhook
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 8 }}>
                  <TextInput
                    name="usageRecordCreateWebhook"
                    value={partner.usageRecordCreateWebhook || ''}
                    onChange={(e) => setPartner({ ...partner, [e.target.name]: e.target.value })}
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={{ base: 12, sm: 4 }}>
                  <Text size="sm" fw={500}>
                    Lift spending limit request webhook
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 8 }}>
                  <TextInput
                    name="liftSpendingLimitRequestWebhook"
                    value={partner.liftSpendingLimitRequestWebhook || ''}
                    onChange={(e) => setPartner({ ...partner, [e.target.name]: e.target.value })}
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={{ base: 12, sm: 4 }}>
                  <Text size="sm" fw={500}>
                    Get subscription change link URL
                  </Text>
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 8 }}>
                  <TextInput
                    name="getSubscriptionChangeLinkUrl"
                    value={partner.getSubscriptionChangeLinkUrl || ''}
                    onChange={(e) => setPartner({ ...partner, [e.target.name]: e.target.value })}
                  />
                </Grid.Col>
              </Grid>
            </>
          )}
          {userError && <ErrorMessage message={userError.message} />}
          <Group justify="flex-end" gap="xs" py="md">
            <Button variant="default" onClick={onClose}>
              Cancel
            </Button>
            <Button
              disabled={!partner?.name || !partner?.email || !partner?.phoneNumber || !partner.billingManagement}
              onClick={savePartner}
            >
              <IconDeviceFloppy size={14} /> Save
            </Button>
          </Group>
        </Box>
      </Modal>
    </>
  );
};

export default PartnerModal;
